module.exports = __webpack_public_path__ + "static/media/amanda.41084729.jpg";